"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotyTypes = void 0;
var NotyTypes;
(function (NotyTypes) {
    NotyTypes[NotyTypes["info"] = 0] = "info";
    NotyTypes[NotyTypes["success"] = 1] = "success";
    NotyTypes[NotyTypes["warning"] = 2] = "warning";
    NotyTypes[NotyTypes["danger"] = 3] = "danger";
})(NotyTypes = exports.NotyTypes || (exports.NotyTypes = {}));
//actual Noty use in sps => string of 
//alert | success | error | alert | warning | info | information ??? 
//alert => confirmations 
//Sps server uses MsgTypes 
//Success = 2 | Error | Warning | Information
exports.default = NotyTypes;
//# sourceMappingURL=NotyTypes.js.map